import React from "react";
import { useNavigate } from "react-router-dom";

function ComicSection() {
  const navigate = useNavigate();

  return (
    <div className="comic-section mt-5">
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <div className="ifi-img">
              <img src="images/comi1.png" alt="" id="if-img" />
              <img src="images/comi2.png" alt="" id="if-img" />
              <img src="images/comi3.png" alt="" id="if-img" />
              <img src="images/comi4.png" alt="" id="if-img" />
            </div>
          </div>
          <div className="col-md-9">
            <div className="ifi-text">
              <h2>INFINITE COMIC PACK</h2>
              <p>
                From shows and movies you can only catch here, to the moments
                the world can't stop watching, stream it all on Infisom
              </p>
              <button className="btn-watch" onClick={() => navigate("/pricing")}>
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComicSection;
